import React from 'react';
import autobind from 'autobind-decorator';

import { PureComponent, Page } from 'core/components';
import { withLocale } from 'core/decorators';
import { CompleteProfile } from 'content/components';

import translations from './i18n';

class CompleteProfilePage extends PureComponent {
  constructor(props) {
    super(props);

    // console.log('edit profile page props:', this.props)

    this.props.translator.addModuleResource('completeProfile', translations);
  };

  render() {
    const { navigate } = this.props;

    return (
      <Page
        pageName="completeProfile"
        showBack={true}
        navigate={navigate}>
        <CompleteProfile
          navigate={this.props.navigate}
        />
      </Page>
    );
  };
};

export default withLocale('completeProfile')(autobind(CompleteProfilePage));
